import { render } from "./MatchWholeWord.vue?vue&type=template&id=1b0629c2"
const script = {}
script.render = render

export default script